<template>
  <Modal title="拒绝工单" v-model="visible">
    <Form
      ref="rejectWoForm"
      class="form"
      :label-width="80"
      :model="formData"
      :rules="ruleWo"
    >
      <Row>
        <Col :span="22">
          <Form-item label="拒绝理由" prop="reason">
            <Select v-model="formData.reason" transfer>
              <Option
                v-for="item in $constant.woReason"
                :value="item.text"
                :key="item.text"
                >{{ item.text }}</Option
              >
            </Select>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <div slot="footer">
      <Button type="text" size="large" @click="visible = false">取消</Button>
      <Button
        type="primary"
        size="large"
        :loading="loadingReject"
        @click="reject"
        >驳回</Button
      >
    </div>
  </Modal>
</template>
<script>
export default {
  name: 'RejectWoModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    studentId: {
      type: Number
    },
    successCallback: {
      type: Function
    }
  },
  data () {
    return {
      visible: this.value,
      loadingReject: false,
      formData: {
        studentId: null,
        reason: null,
      },
      ruleWo: {
        reason: [
          { type: 'string', required: true, message: '理由不能为空', trigger: 'blur' },
        ],
      },
    }
  },
  methods: {
    reject () {
      let self = this
      self.loadingReject = true
      self.$refs.rejectWoForm.validate((valid) => {
        if (!valid) {
          self.$Message.warning('信息输入错误!')
          self.loadingReject = false
          return
        }
        self.$http.post('/sale/wo/reject', self.formData).then(function (res) {
          if (res && res.data > 0) {
            self.visible = false
            self.$Message.success('提交成功!')
            self.successCallback()
          }
          self.loadingReject = false
        }).catch(function (e) {
          self.loadingReject = false
        })
      })
    },
  },
  watch: {
    studentId (val) {
      if (val) {
        this.formData.studentId = val
      }
    },
    value (val) {
      this.visible = val
    },
    visible (val) {
      if (val === true) {
      } else {
        this.formData = {}
        this.$emit('on-close', val)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// RejectWoModal.vue?2e58eb6a